import ViewRateModal from "./ViewRateModal";

export default ViewRateModal